import t from "./highrise1841.mjs";
function e() {
  this.__data__ = t ? t(null) : {}, this.size = 0;
}
export {
  e as default
};
